export default __webpack_public_path__ + "static/whatsahead-e58b2ff139e5379f3f01deacb0e13174.jpg";